import { connect } from 'react-redux';

import {
  scheduledPostCount,
  nextScheduledPost,
} from '../../../../../../../core/selectors/classroom';
import openScheduledPosts from '../../../../../../actions/navigation/openScheduledPosts';
import SchedulePostsSummary from './ScheduledPostsSummary';

const mapStateToProps = (state) => ({
  scheduledPostCount: scheduledPostCount(state),
  post: nextScheduledPost(state),
});

const mapDispatchToProps = (dispatch) => ({
  openScheduledPosts: () => dispatch(openScheduledPosts()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SchedulePostsSummary);
